// extracted by mini-css-extract-plugin
export default {"poster":"frontend_style__poster--4GrwJ","popover":"frontend_style__popover--2mLJb"};
    if(module.hot) {
      // 1783344146303
      var cssReload = require("/bento3/bento_cms/static_src/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  